var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("pz-form-flujo", {
    attrs: {
      forward: _vm.handleSave
    }
  }, [_c("span", {
    attrs: {
      slot: "form_title"
    },
    slot: "form_title"
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.consultar_solicitud.title")) + " ")]), _c("el-form", {
    ref: _vm.reference,
    attrs: {
      slot: "formulario",
      model: _vm.formulariodocumentacion,
      "status-icon": "",
      rules: _vm.rules_formulariodocumentacion
    },
    on: {
      validate: _vm.handleValidate
    },
    slot: "formulario"
  }, [_c("el-row", {
    attrs: {
      gutter: 20,
      type: "flex",
      justify: "center"
    }
  }, [_c("el-col", {
    attrs: {
      xl: {
        span: 12
      },
      lg: {
        span: 12
      },
      md: {
        span: 12
      },
      sm: {
        span: 24
      },
      xs: {
        span: 24
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "numero_documento",
      error: _vm.errors.get("numero_documento")
    }
  }, [_c("pz-identity-document", {
    ref: "numero_documento",
    attrs: {
      prop: "numero_documento",
      type: "person",
      "type-label": _vm.$t("forms_flujo.form1_persona.UY.tipo_doc"),
      "number-label": _vm.$t("forms_flujo.form1_persona.UY.identity_doc")
    },
    model: {
      value: _vm.formulariodocumentacion.numero_documento,
      callback: function callback($$v) {
        _vm.$set(_vm.formulariodocumentacion, "numero_documento", $$v);
      },
      expression: "formulariodocumentacion.numero_documento"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20,
      type: "flex",
      justify: "center"
    }
  }, [_c("el-col", {
    attrs: {
      xl: {
        span: 12
      },
      identity: "",
      lg: {
        span: 12
      },
      md: {
        span: 12
      },
      sm: {
        span: 24
      },
      xs: {
        span: 24
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "numero_solicitud",
      label: _vm.$t("forms_flujo.validacion_sms_default.numero_solicitud"),
      error: _vm.errors.get("numero_solicitud")
    }
  }, [_c("el-input", {
    attrs: {
      type: "text",
      placeholder: _vm.$t("forms_flujo.validacion_sms_default.numero_solicitud")
    },
    model: {
      value: _vm.formulariodocumentacion.numero_solicitud,
      callback: function callback($$v) {
        _vm.$set(_vm.formulariodocumentacion, "numero_solicitud", $$v);
      },
      expression: "formulariodocumentacion.numero_solicitud"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };